import React from 'react';
import Button from '@mui/material/Button';
import styles from '../../../assets/jss/components/Common/smallButtonStyles';
import { CircularProgress } from '@mui/material';

function SmallButton(props) {
  const classes = styles(props)();
  const { label, color, handleClick, loading, disabled, id, onMouseEnter, onMouseLeave } = props;

  return (
    <Button
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      id={id}
      className={`${classes.rootButton} ${color}`}
      onClick={handleClick}
      disabled={disabled}
    >
      {loading ? <CircularProgress color="primary" size="22px" /> : label}
    </Button>
  );
}

export default SmallButton;
